export default __webpack_public_path__ + "media/components/Courses/Show/Images/features-445ad85dd275ed6293e28c3cfe66f897.svg";